module.exports = __webpack_public_path__ + "img/imgplacehold.e7e501ce.png";